import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Container,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

const testimonials = [
  {
    name: "Elen A.",
    rating: 5,
    text: "Wow, just wow! The graze box was an absolute masterpiece. Every item felt like it was handpicked for its freshness and flavor. It wasn’t just a feast for the palate but also for the eyes—so beautifully arranged!",
  },
  {
    name: "Heather M.",
    rating: 5,
    text: "The level of care and detail that went into our charcuterie board was unmatched. From the perfectly paired cheeses and cured meats to the delicious little surprises like gourmet dips and chocolates, everything was flawless.",
  },
  {
    name: "Ian D.",
    rating: 5,
    text: "Our office event was a hit thanks to this stunning grazing board! Not only was it delicious, but it was also a conversation starter. The variety was incredible—something for everyone, from savory to sweet.",
  },
];

const TestimonialsSection = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ paddingTop: 8, paddingBottom: 8 }}>
        {/* Section Title */}
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: 4,
            fontFamily: "Moul",
          }}>
          Celebrated for gatherings, gifts, and corporate events.
        </Typography>

        {/* Testimonials */}

        <Grid container spacing={4}>
          {testimonials.map((testimonial, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ height: "100%", boxShadow: 3 }}>
                <CardContent>
                  {/* Star Rating */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: 1,
                    }}>
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <StarIcon key={i} sx={{ color: "#FFD700" }} />
                    ))}
                  </Box>
                  {/* Name */}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", marginBottom: 2 }}>
                    {testimonial.name}
                  </Typography>
                  {/* Text */}
                  <Typography variant="body1">{testimonial.text}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default TestimonialsSection;
